module.exports = [{
      plugin: require('../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"heapsgo","short_name":"heapsgo","start_url":"/","background_color":"#fff","theme_color":"#000","display":"minimal-ui","icon":"src/assets/favicons/thefatgreek.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"242f843fed3a6f9eac213c697df845bc"},
    },{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"q0QFYDfYj5eWNdVLiKDpyS5pBTDTe86k","devKey":"8ZP7MzUwIjtwMNICyKbuFIOF50MuVe4A","trackPage":true,"delayLoad":true,"manualLoad":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["en","da","no","is","sv","de","nl","fr"],"defaultLanguage":"en","siteUrl":"https://thefatgreek.heapsgo.com","trailingSlash":"always","generateDefaultLanguagePage":true,"i18nextOptions":{"keySeparator":false,"nsSeparator":false},"pages":[{"matchPath":"/password-recovery/:organizationKeyName","languages":["en"]},{"matchPath":"/card-form","languages":["en"]}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
